import axiosClient from './axiosClient';
import {
  IAlert24h,
  IOverview,
  IRecentAlert,
  IDashboardParams,
  IGetAlertStats,
  IResultAreaStats,
  IResultNewPersonStats,
} from '~/utils/interface/dashboard';

const url: string = '/api/dashboard';

const dashboardApi = {
  getOverviewData(params: IDashboardParams) {
    return axiosClient.get<IOverview>(url + '/over-view', { params });
  },

  getAlert24h(params: IDashboardParams) {
    return axiosClient.get<IAlert24h>(url + '/alert-24h', { params });
  },

  getAlertStas(params: IDashboardParams) {
    return axiosClient.get<IGetAlertStats>(url + '/alert-stats', { params });
  },

  getRecentAlert(params: IDashboardParams) {
    return axiosClient.get<IRecentAlert>(url + '/recent-alert', { params });
  },

  getAreaStats(params: IDashboardParams) {
    return axiosClient.get<IResultAreaStats>(url + '/area-stats', { params });
  },

  getNewPersonStats(params: IDashboardParams) {
    return axiosClient.get<IResultNewPersonStats>(url + '/new-persons-stats', { params });
  },
};

export default dashboardApi;
